import { render, staticRenderFns } from "./TrademarkApplicationType.vue?vue&type=template&id=bcfd28e8&"
import script from "./TrademarkApplicationType.vue?vue&type=script&lang=js&"
export * from "./TrademarkApplicationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports